enum MedicareParentOrganizationSortingTypeEnum {
  MembershipDesc = "Membership (high to low)",
  MembershipAsc = "Membership (low to high)",
  AlphabeticalAsc = "Alphabetical (A-Z)",
  AlphabeticalDesc = "Alphabetical (Z-A)",
}

export { MedicareParentOrganizationSortingTypeEnum };
